export default {
    InternalSalesOrderDetails: {
        aftersales: '创建售后单',
        Delivery: '交货时间',
        toCSGMANUAL: '一键改为 CSG MANUAL',
        refund: '创建仅退款单',
        return: '创建退货退款单',
        Resend: '创建重发单',
        Reissue: '创建补发单',
        Cancel: '取消订单',
        CancelSap: '取消SAP订单',
        Copy: '复制订单',
        Confirm: '确认收货',
        Pending: '挂起',
        Unhook: '解挂',
        statistics: '订单统计',
        the: '该订单下所有商品行完成情况统计',
        Order: '订单状态',
        Completed: '已完成',
        Incomplete: '未完成',
        Canceled: '已取消',
        not: '未完成统计',
        on: '未完成商品行当前状态统计',
        of: '缺货',
        failed: '寻源失败',
        be: '待发货',
        Reservation: '预占成功待审核',
        Successful: '寻源成功待审核',
        Pend: '待处理',
        Abnormal: '商品行状态异常需人工处理',
        Out: '缺货',
        Sourcing: '寻源失败',
        approved: '待审核',
        Pre: '预占回写失败',
        Shipment: '发货回写失败',
        Add: '添加标签',
        Basic: '基础信息',
        type: '订单类型',
        party: '客户订单号',
        Internal: '内部订单号',
        Store: '店铺',
        Three: '三方下单时间',
        creation: '内部创单时间',
        Buyer: '买家备注',
        Modify: '修改',
        History: '历史快照',
        Comments: '备注',
        CommentsHistory: '入库单备注历史',
        Current: '当前备注',
        Merchant: '商家备注',
        Customer: '客服备注',
        Receiving: '收货信息',
        nickname: '买家昵称',
        Consignee: '收货人',
        Phone: '手机',
        Address: '地址',
        Amount: '金额信息',
        FreiTotalght: '商品总金额',
        payable: '买家应付总金额',
        cost: '成本总金额',
        information: '支付信息',
        Payment: '支付方式',
        status: '支付状态',
        time: '支付时间',
        actual: '买家实付金额',
        Yuan: '元',
        Invoice: '发票信息',
        View: '查看详情',
        voice: '发票类型',
        header: '发票抬头',
        content: '发票内容',
        invoicing: '暂无开票申请',
        Serial: '序号',
        Document: '单据编号',
        Documenttype: '单据类型',
        StatusS: '状态',
        Orderinformation: '订单信息',
        Product: '商品信息',
        Image: '图片信息',
        Logistics: '物流信息',
        internInfo: '内部信息',
        WarehouseRemarks: '仓库备注',
        logisticsComment: '物流备注',
        Documentinformation: '单据信息',
        want: '温馨提醒 ：是否确认执行该操作 ？',
        Operation: '操作中，是否继续？',
        Create: '创建仅退款单',
        Greturnoods: '创建退货单',
        returnAdd: '创建退货退款单',
        delete: '是否删除此标签？',
        error: '订单信息错误：orderInfoVO.innerOrderNo=',
        sure: '是否确认收货？',
        Marking: '打标',
        Pleaseselect: '请选择',
        OrderAwaiting1: '订单已推送仓库或已发货,是否确认取消',
        OrderAwaiting2: '订单已推送仓库或已发货,请联系客服取消',
        cancelSAPFirst: '请确认已经取消了sap',
        orderShipped: '取消失败，订单已发货',
        send: '推送',
        customerDelivery: '提货',
        ReturnLabel: '退件',
        errMsgText: '物流信息和运费不能为空!',
        shippingLabel: '物流单',
        shippingLabelUpdate: '文件上传',
        CourierLabelUpdate: '快递面单',
        closeOrderTip: '是否关闭订单',
        closeOrder: '关单',
        pickUpTime: '提货时间',
        shippingCost: '请确认运费金额是否正确？',
        duplicateTrackingConfirm: '该运单号已存在，可能为合并发货，请核实后添加。',
        duplicateTrackingBack: '返回',
        duplicateTrackingVerified: '已核实',
        PaymentInformation: '支付信息',
        PaymentInfo: '支付信息',
        CustomerName: '客户名称',
        PaymentStatus: '支付状态',
        PaymentId: '支付单号',
        InvoiceNo: '发票单号',
        OrderDate: '订单日期',
        InvoiceWeek: '发票周数',
        PaymentTableNO: '序号',
        PaymentTableItem: '收费项',
        PaymentTableQty: '数量',
        PaymentTablePrice: '单价',
        PaymentTableTotal: '小计',
        PaymentTableSubTotal: '小计',
        PaymentTableGST: '税',
        PaymentTableSubTotalGST: '合计（含税）',
    }
};
